$(document).on('show.bs.modal', function (event) {
  let button = $(event.relatedTarget) // Button that triggered the modal
  let fetch_path = button.data('fetch-path')
  let title = button.data('modal-title')
  let modal = $(button.data('target'))

  if (fetch_path) {
    fetch(fetch_path)
      .then((data) => data.text())
      .then((html) => {
        if (title) {
          modal.find('.modal-title').html(title)
        }
        modal.find('.modal-body').html(html)
      });
  }
})
